import {createAsyncThunk} from '@reduxjs/toolkit';
import {CLDispatch, RootState} from 'common/src/redux/store';
import {setBrandImages} from '../brandAssets.slice';
import brandAssetsApi from 'common/src/modules/Assets/brandAssets/brandAssets.api';
import {AssetType} from 'common/src/modules/Assets/Assets.enums';

export const loadBrandImages = createAsyncThunk<
  void,
  void,
  {dispatch: CLDispatch; state: RootState}
>('brandAssets/loadBrandImages', async (_, {dispatch, rejectWithValue}) => {
  try {
    const assets = await brandAssetsApi.getBrandAssets(AssetType.Image);
    dispatch(setBrandImages(assets));
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to fetch brand image assets';

    return rejectWithValue(errorMessage);
  }
});
